import { schema } from "..";

export function selectPrevious(args) {
    var observable = args.observable;
    var grid = args.grid;
    var e = args.e;
    var keyProperty = args.keyProperty || "Id";
    var found = false;
    if (observable) {
        $.each(e.sender._data, function (index, data) {
            if (observable[keyProperty] == data[keyProperty]) {
                var uid = data.uid;

                var row = grid.tbody.find('tr[data-uid="' + uid + '"]');

                grid.select(row);
                found = true;
                return false;
            }
            return true;
        });
    }

    if (!found && args.autoSelect !== false) {
        grid.select(e.sender.tbody.find("tr:first"));
    }

    let scrollContentOffset = grid.element.find("tbody").offset().top;
    let selectedRow = grid.select();

    if (selectedRow.length != 0) {
        let selectContentOffset = selectedRow.offset().top;
        let distance = selectContentOffset - scrollContentOffset;

        grid.element.find(".k-grid-content").stop().animate({
            scrollTop: distance
        }, 400);
    }
}

/*
* getGridSelectedItem
* Takes in a DOM reference to a grid component and returns an object containing the object
* bound to the selected grid row.
*
* reference - jquery friendly reference to the grid component
*
*/
export function getGridSelectedItem(reference) {
    var grid = $(reference).data("kendoGrid");

    if (grid) {

        return grid.dataItem(grid.select());
    } else {
        return null;
    }
}

export function lastPage(dataSource) {
    var pagesize = dataSource.pageSize();
    var sort = dataSource.sort();
    var numelements = dataSource._pristineTotal;
    var page = Math.ceil(numelements / pagesize);
    if (numelements % pagesize == 0) {
        page++;
    }
    return dataSource.query({ page: page, pageSize: pagesize, sort: sort});
}

export function firstPage(dataSource) {
    return dataSource.page(1);
}

export function setGridMinimumWidth(grid, columns) {
    var minimumWidth = calculateMinimumGridWidth(columns);
    grid.find(".k-grid-header table").css({ minWidth: minimumWidth });
    grid.find(".k-grid-content table").css({ minWidth: minimumWidth });
}

export function calculateMinimumGridWidth(columns) {
    var width = 0;

    if (!columns || columns.length == 0) {
        return width;
    }

    for (var i = 0; i < columns.length; i++) {
        if (columns[i].hidden) {
            continue;
        }
        if (columns[i].width) {
            width += columns[i].width;
        } else {
            width += 80; // Arbitrary number for how many pixels a
            // column should receive if a width is not specified
        }
    }

    return width;
}

export function allowNullFilters(entity: string, field: string) {
    var property: any;

    try {
        property = schema.getPropertyInfo({
            entityName: entity,
            path: field
        }).property;
    } catch (e) {}

    return property ? !property.Required || property.Type === "String" : true;
}
